import * as React from 'react'

export interface IAttributes {
  useCompact: boolean
  textType: string
  elementType: ElementType
  spacing: string
  content: string
  color?: string
  align?: 'center' | 'left' | 'right' | 'justify'
}

export enum ElementType {
  HEADING1 = 'HEADING1',
  HEADING2 = 'HEADING2',
  HEADING3 = 'HEADING3',
  HEADING4 = 'HEADING4',
  HEADING5 = 'HEADING5',
  HEADING6 = 'HEADING6',
  SPAN = 'SPAN',
  PARAGRAPH = 'PARAGRAPH',
  SMALL = 'SMALL',
}

const textElementMap: Record<ElementType, (text: string) => React.ReactElement> = {
  [ElementType.HEADING1]: (text: string) => <h1 dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.HEADING2]: (text: string) => <h2 dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.HEADING3]: (text: string) => <h3 dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.HEADING4]: (text: string) => <h4 dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.HEADING5]: (text: string) => <h5 dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.HEADING6]: (text: string) => <h6 dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.SMALL]: (text: string) => <small dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.SPAN]: (text: string) => <span dangerouslySetInnerHTML={{ __html: text }} />,
  [ElementType.PARAGRAPH]: (text: string) => <p dangerouslySetInnerHTML={{ __html: text }} />,
}

export const getMarkupTextContent = (type: ElementType, text: string) =>
  textElementMap[type] ? textElementMap[type](text) : text
